const valueAt = (source, path) =>
  path.split('.').reduce((value, key) => value?.[key], source);

const recordIdFromResponse = response => {
  const paths = [
    'id',
    'data.id',
    'payload.id',
    'property_transaction.id',
    'post_sale_case.id',
    'transaction.id',
  ];

  return paths.map(path => valueAt(response, path)).find(Boolean) || null;
};

export { recordIdFromResponse };
